const sisenseDashboard = [
  {
    title: 'security',
    dashboards: [
      {
        dashboardOid: '6894cd40870e9c0033b017a7',
        isWidgetRequired: false,
      },
      {
        dashboardOid: '64f9deed86d5a1003323adb8',
        widgetLists: ['64f9deed86d5a1003323adb9', '64f9deed86d5a1003323adbb'],
      },
    ],
  },
  {
    title: 'devops',
    dashboards: [
      {
        dashboardOid: '635fd368dae09d0036b480cb',
        widgetLists: ['636da133dae09d0036b48394'],
      },
      {
        dashboardOid: '655625e324082a0033031ef9',
        // widgetLists: ['655626ed24082a0033031f3c'],
        isWidgetRequired: false,
      },
    ],
  },
  {
    title: 'quality',
    dashboards: [
      {
        dashboardOid: '6785f86221ddb500346df4c0',
        widgetLists: ['67908fcc435f6f0033922a97'],
      },
      {
        dashboardOid: '63b9cf36dae09d0036b4b423',
        widgetLists: ['68bee4438c6d540033afffcb'],
      },
    ],
  },
  {
    title: 'automation',
    dashboards: [
      {
        dashboardOid: '669e20894c1d7d00334ca0f7',
        isWidgetRequired: false,
      },
    ],
  },
  {
    title: 'code coverage',
    dashboards: [
      {
        dashboardOid: '65ddc8d324082a00330a6113',
        isWidgetRequired: false,
      },
    ],
  },
];

export default sisenseDashboard;
